import { FactRows, TechInsightsCheck } from "./types";

/** A fact from the first of the check's retrievers whose latest row has it. @public */
export function latestFactValue(
  check: Pick<TechInsightsCheck, "factIds">,
  rows: FactRows | undefined,
  factId: string
): unknown {
  for (const retrieverId of check.factIds ?? []) {
    const value = rows?.[retrieverId]?.facts?.[factId];
    if (value !== null && value !== undefined) return value;
  }
  return undefined;
}
